import { render, staticRenderFns } from "./SubscriptionForAnonim.vue?vue&type=template&id=5ab67d42&lang=pug"
import script from "./SubscriptionForAnonim.vue?vue&type=script&lang=js"
export * from "./SubscriptionForAnonim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports